import { migrateLegacyPageStorage } from './core/utils/page-storage';
import { migrateLegacyPreferences } from './core/utils/preferences.storage';
import { migrateLegacyPageSizeStorage } from './core/table/page-size.storage';
import { setStorageUser } from './core/utils/storage';
import { migrateLegacyDashboardStorage } from './dashboard/dashboard.storage';

/**
 * Folds the flat entries written before 7.122 into the grouped ones, and drops what became
 * obsolete. Called from `main.ts` before the bootstrap, so nothing reads an entry before it moves.
 * The grouped entries then move into the cache of the user signing in, at hydration.
 *
 * Temporary: drop this file, its call in `main.ts` and the four `migrateLegacy*` functions once
 * every client has run a version carrying it.
 */
export function migrateLegacyStorage(): void {
  try {
    // Both the entries read and the ones written sit at the root: no user cache is involved yet.
    setStorageUser(null);
    migrateLegacyPageStorage();
    migrateLegacyPreferences();
    migrateLegacyPageSizeStorage();
    migrateLegacyDashboardStorage();
  } catch (_) {
    // Running before the bootstrap: a throw here would leave the user with a blank page.
  }
}
